import React from 'react';
import Plot from 'react-plotly.js';
import * as Const from '../../../utils/Const';

interface TrainingCorrectNumberProps {
  data?: any; // 引数として渡すプロパティ
}

function transformToPlotlyData(sqlData: any[]) {
  if (!sqlData || sqlData.length === 0) return { header: [], columns: [[]] };

  // ヘッダーを取得
  const header = Object.keys(sqlData[0]);

  // 列単位のデータを生成
  const columns = header.map((key) => sqlData.map((row) => row[key]));

  return { header, columns };
}

export const TrainingCorrectNumber: React.FC<TrainingCorrectNumberProps> = ({ data }) => {
  const dataList = data || [];
  const plotlyData = transformToPlotlyData(dataList);

  const graphData: any[] = [
    {
      type: 'bar',
      x: plotlyData.columns[1],
      y: plotlyData.columns[0],
      orientation: 'h',
      text: plotlyData.columns[1], // 棒グラフ上に表示する数値
      textposition: 'outside', // 数値を棒の外側に表示
      textfont: {
        size: 20, // 数値のフォントサイズを指定
      },
      marker: {
        color: `${Const.GraphBaseColor}`, // 棒グラフの色を指定
      },
    },
  ];

  if (dataList.length === 0) return <></>;

  return (
    <>
      <details className="rounded-3xl shadow-custom-lg overflow-hidden bg-white ml-2 mr-4 mt-2 mb-8">
        <summary className="cursor-pointer px-4 py-3 text-4xl">設問別 正答者数</summary>
        <Plot
          data={graphData}
          layout={{
            xaxis: {
              title: {
                // text: '正答率（%）', // X軸の単位
                text: '正答者数', // X軸の単位
                font: { size: 20 }, // X軸タイトルのフォントサイズ
              },
              tickfont: {
                size: 20, // X軸の値のフォントサイズを指定
              },
            },
            yaxis: {
              automargin: true, // Y軸のマージンを自動調整
              tickmode: 'array', // すべての値を表示
              tickvals: plotlyData.columns[0], // Y軸の値を明示的に指定
              ticktext: plotlyData.columns[0], // Y軸に表示するテキスト
              tickfont: {
                size: 20, // Y軸の値のフォントサイズを指定
              },
              ticklabelposition: 'inside', // Y軸の文字を左寄せに設定
            },
            margin: {
              t: 20, // 上部のマージンを確保
              l: 300, // 必要最小限の左マージン
              r: 40,
              b: 80,
            },
            autosize: true,
          }}
          config={{
            responsive: true, // レスポンシブデザインを有効にする
            displayModeBar: false, // モードバーを非表示にする
            displaylogo: false, // Plotlyロゴを非表示にする
            staticPlot: true, // プロットを静的にする
          }}
          style={{ width: '100%', height: '100%', minHeight: '450px' }}
        />
      </details>
    </>
  );
};
